import shortId from 'shortid';

export default () => shortId.generate();
